import { USD_UNIT, type BsvUnit } from 'lib/bsv-util'

export type MoneyColorMode = 'bitcoin' | 'usd'

export function resolveMoneyColorMode(bsvUnit: BsvUnit): MoneyColorMode {
    return bsvUnit === USD_UNIT ? 'usd' : 'bitcoin'
}
